import React from 'react'
import styled from 'styled-components'

import Tooltip from 'components/Tooltip'
import KeyboardAccessible from 'components/KeyboardAccessible'

import { color } from 'styles/colors'

interface FieldExplanationProps {
  tooltipContent: string
  className?: string
}

const FieldExplanation = ({ tooltipContent, className = '' }: FieldExplanationProps) => (
  <Tooltip title={tooltipContent} placement="top">
    <S.QuestionMarkIcon readOnly className={className + ' icon-question3'}>
      &nbsp;
    </S.QuestionMarkIcon>
  </Tooltip>
)

export default FieldExplanation

const S = {
  QuestionMarkIcon: styled(KeyboardAccessible)`
    color: ${color('questionMarkIcon')};
    padding: 5px;
  `
}
